module.exports = __webpack_public_path__ + "img/Homepage-Alligator.a3da7797.svg";